
import EmployteeTermination from "./TerminateEmployee"


export default class TerminateStepsManager {

    static getQueryParam(location, param) {
        if (location?.search && param) {
            const query = new URLSearchParams(location.search);
            return query.get(param);
        }

        return null;
    }

    static getAllCreationSteps(onClickHandler) {
    
        return [
                {
                    title: "Details",
                    getChild: (props) => (
                        <EmployteeTermination
                            {...props}
                            key={"1"}
                            userId={props.employeeId}
                            fileInfo={props.state.fileInfo}
                            setData={props.setData}
                            onStoreDataUpdate={props.handleCallback}
                            isAction={true}
                            checkValid={props.checkValid}
                        />
                    ),
                    onClick: (event) => onClickHandler(event, 0),
                },
    
                {
                    title: "Review",
                    getChild: (props) => (
                        <EmployteeTermination
                            {...props}
                            key={"2"}
                            userId={props.employeeId}
                            fileInfo={props.state.fileInfo}
                            setData={props.setData}
                            onStoreDataUpdate={props.handleCallback}
                            isAction={false}
                        />
                    ),
                    onClick: (event) => onClickHandler(event, 1),
                }

        ]
    }

}